<template>
  <b-row class="overflow myModal">
    <div class="mobile">
      <div class="link">
        <button class="bt btn-back" v-b-toggle.sidebar-collaborateur>
          <font-awesome-icon :icon="['far', 'times']"/>
        </button>
        <h3>Ajouter un collaborateur</h3>
      </div>
      <div class="sep"></div>
    </div>

    <div class="scrollable form__addCollab">
    <b-overlay
      id="overlay-challenge"
      :show="show"
      rounded="sm"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      style="position:initial!important"          
    >  

      <div class="col">
        <b-card>
          <b-form-group
            id="input-group-1"
            :label="formContent.formName"
            label-for="collab-name"
          >
            <b-form-input
              id="collab-name"
              v-model="form.lastName"
              required
              :placeholder="formContent.formNamePlaceholder"
              @change="activeFormButton()"
            ></b-form-input>
          </b-form-group>   


          <b-form-group
            id="input-group-1"
            :label="formContent.formFirstname"
            label-for="collab-firstname"
          >
            <b-form-input
              id="collab-firstname"
              v-model="form.name"
              required
              :placeholder="formContent.formFirstnamePlaceholder"
              @change="activeFormButton()"
            ></b-form-input>
          </b-form-group>   

          <b-form-group
            id="input-group-1"
            :label="formContent.formEmail"
            label-for="collab-email"
          >
            <b-form-input
              id="collab-email"
              v-model="form.email"
              required
              type="email"
              :placeholder="formContent.formEmailPlaceholder"
              @change="activeFormButton()"
            ></b-form-input>
          </b-form-group>   
          <Stack></Stack>
          <button class="btn btn-send" @click="newCollab"  :disabled="notActivated" v-if="!stateModify">Ajouter</button>
          <button class="btn btn-send" @click="updateCollab"  :disabled="notActivated" v-else>Modifier</button>
        </b-card>
      </div>
    </b-overlay>
    </div>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex'
import Stack from '../stack/Stack';
import ApiService from '../../../services/ApiService'
import utils from '../../Utils'

export default {
  name: "FormCollab",
  components: {
    Stack
  },
  data() {
    return {
        notActivated:true,
        general:'',
        show:false,
        stateModify:false,
        form: {
          name: '',
          lastName: '',
          email: '',
        },
    }
  },
  computed: {
    ...mapGetters([
        'getGeneral',
        'getCollabInfos',
    ])
  },

  created (){
    //PASS ALL THE GENERAL TRANSLATE
    this.formContent = this.getGeneral;
    this.general = this.getGeneral;
  },  
  methods:{
      //GET NEW COLLAB
      async newCollab(){
        this.show = true;
        let patched = await ApiService.getCollaboratorApi().post(this.form);
        patched.status == '200' ?  this.messageSuccess(true) : this.messageError();
        this.show = false;
      }, 

      //PATCH COLLAB      
      async updateCollab(){
        this.show = true;
        let patched = await ApiService.getCollaboratorApi().patch(this.form.id, this.form);
        patched.status == '200' ?  this.messageSuccess() : this.messageError();
        this.show = false;
      }, 

      //IF SUCCESS
      messageSuccess($reset){
        this.makeToast('success');
        this.$store.dispatch('setNewCollab');
        $reset ? this.reset() : '';
      },

      //IF ERROR
      messageError(){
        this.makeToast('error')
      },  

      //UPDATED INFOS
      updatedInfo(data){
        this.form = data;
      },

      //SHOW THE TOAST
      makeToast(variant = null) {
        if(variant == 'success'){
          this.$bvToast.toast(this.general.collabSuccess, {
            title: this.general.collabToastTitle,
            variant: variant,
            solid: true,
            toaster:'b-toaster-top-center'
          })  
        } else if(variant == 'error'){
          this.$bvToast.toast(this.general.collabError, {
            title: this.general.collabToastTitle,
            variant: variant,
            solid: true,
            toaster:'b-toaster-top-center'
          }) 
        } 
        // else if(variant == 'info'){
        //   this.$bvToast.toast('Le challenge a été mis à jour.', {
        //     title: `Enregistrement challenge`,
        //     variant: 'success',
        //     solid: true,
        //     toaster:'b-toaster-top-center'
        //   }) 
      },

      //RESET THE FORM
      reset(){
        this.form = {
          name: '',
          lastName: '',
          email: '',
        }
      },

      //CHECK IF THE EMAIL IS GOOD
      checkMail(){
        if(!utils.validEmail(this.userId)){
            this.emailError = true;
          }else{
            this.emailError = false;
            this.activeFormButton()
          }
      },

      //UNDISABLED THE BUTTON IF EVERYTHING IS OK
      activeFormButton(){
        utils.validEmail(this.form.email) && this.form.name != '' && this.form.lastName != '' ? this.notActivated = false : this.notActivated = true;
      },      

      //GO BACK
      goBack() {
        this.$router.push({name: "profileCollab"});  
      },       
  } ,
  watch :{
    //WATCH IF UPDATES COLLAB INFOS
    'getCollabInfos': function () {
      this.updatedInfo(this.getCollabInfos);
      this.stateModify = this.getCollabInfos.id ? true : false;
    }
  } 
}
</script>

